<template>
  <div class="todayReport">
    <div class="userList-search-button">
      <a-button type="primary" @click="queryPage()">查询</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :loading="loadingTable"
      :pagination="false"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="submit" slot-scope="text, record">
        {{ text }}
        <a-tooltip
          placement="topLeft"
          v-if="
            record.platformSubmitList && record.platformSubmitList.length > 0
          "
        >
          <template slot="title">
            <template v-for="item in record.platformSubmitList">
              <span>{{ item.platformName }} : {{ item.count }}</span
              ><br />
            </template>
          </template>
          <a-icon type="info-circle" />
        </a-tooltip>
      </span>
      <span slot="complete" slot-scope="text, record">
        {{ text }}
        <a-tooltip
          placement="topLeft"
          v-if="
            record.platformCompleteList &&
            record.platformCompleteList.length > 0
          "
        >
          <template slot="title">
            <template v-for="item in record.platformCompleteList">
              <span>{{ item.platformName }} : {{ item.count }}</span
              ><br />
            </template>
          </template>
          <a-icon type="info-circle" />
        </a-tooltip>
      </span>
      <span slot="show" slot-scope="text, record">
        {{ text }}
        <a-tooltip
          placement="topLeft"
          v-if="record.platformShowList && record.platformShowList.length > 0"
        >
          <template slot="title">
            <template v-for="item in record.platformShowList">
              <span>{{ item.platformName }} : {{ item.count }}</span
              ><br />
            </template>
          </template>
          <a-icon type="info-circle" />
        </a-tooltip>
      </span>
      <span slot="order" slot-scope="text, record">
        {{ text }}
        <a-tooltip
          placement="topLeft"
          v-if="record.platformOrderList && record.platformOrderList.length > 0"
        >
          <template slot="title">
            <template v-for="item in record.platformOrderList">
              <span>{{ item.platformName }} : {{ item.count }}</span
              ><br />
            </template>
          </template>
          <a-icon type="info-circle" />
        </a-tooltip>
      </span>
    </a-table>
  </div>
</template>
<script>
import api from "../lib/todayReport.js";

export default {
  name: "todayReport",
  data() {
    return {
      channel: "",
      pageNo: 1,
      tableColumns: [
        {
          title: "渠道",
          dataIndex: "channel",
          customRender: (text, row, index) => {
            if (index === this.tableDataSource.length - 1) {
              return {
                children: <span>合计</span>,
              };
            }
            return <span>{text}</span>;
          },
        },
        {
          title: "UV",
          dataIndex: "uv",
        },
        {
          title: "注册",
          dataIndex: "register",
        },
        {
          title: () => {
            return (
              <span>
                完件
                <a-tooltip placement="topLeft">
                  <template slot="title"> 完成表单 </template>
                  <a-icon type="info-circle" />
                </a-tooltip>
              </span>
            );
          },
          dataIndex: "fill",
        },
        {
          title: () => {
            return (
              <span>
                交单
                <a-tooltip placement="topLeft">
                  <template slot="title"> 推送成功 </template>
                  <a-icon type="info-circle" />
                </a-tooltip>
              </span>
            );
          },
          dataIndex: "submit",
          scopedSlots: { customRender: "submit" },
        },
        {
          title: () => {
            return (
              <span>
                进件
                <a-tooltip placement="topLeft">
                  <template slot="title"> 推送成功,平台审核成功 </template>
                  <a-icon type="info-circle" />
                </a-tooltip>
              </span>
            );
          },
          dataIndex: "complete",
          scopedSlots: { customRender: "complete" },
        },
        {
          title: () => {
            return (
              <span>
                展示
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    推送成功,平台审核成功,展示给用户
                  </template>
                  <a-icon type="info-circle" />
                </a-tooltip>
              </span>
            );
          },
          dataIndex: "show",
          scopedSlots: { customRender: "show" },
        },
        {
          title: "成单",
          dataIndex: "order",
          scopedSlots: { customRender: "order" },
        },
      ],
      tableDataSource: [],
      loadingTable: false,
    };
  },
  mounted() {
    this.queryPage();
  },
  methods: {
    close() {
      this.intoOrderTableSource.splice(0);
    },
    // 查询列表
    queryPage() {
      this.loadingTable = true;
      api
        .queryPage()
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            this.tableDataSource = res.data.report;
            this.tableDataSource.push(res.data.summarize);
            this.tableDataSource.forEach((item, index) => {
              this.$set(item, "id", index + 1);
            });
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
  },
};
</script>
<style lang="scss">
.todayReport {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
}
</style>
